import { Colors } from '@mercator-gcp/grout';
import { Polygon } from '@react-google-maps/api';
import { useSelectedPolygonBoundsOnMap } from 'state/map';
import { Z_INDEX_DICT } from 'utils/constants/zIndex';
import { getPolygonFromBoundingBox } from 'utils/polygons';

const SelectedPolygon = ({ onClick }: { onClick: (arg0: string) => void }) => {
  const [selectedPolygonBounds] = useSelectedPolygonBoundsOnMap();

  if (!selectedPolygonBounds) {
    return null;
  }

  const polygonBounds = getPolygonFromBoundingBox(selectedPolygonBounds);

  return (
    <Polygon
      key={`selected-map-polygon-${selectedPolygonBounds}`}
      paths={polygonBounds}
      options={{
        strokeColor: Colors.Tangerine700,
        strokeOpacity: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.25,
        fillColor: Colors.Tangerine700,
        zIndex: Number(Z_INDEX_DICT.SELECTED_POLYGON),
      }}
      onClick={() => {
        onClick(selectedPolygonBounds);
      }}
    />
  );
};

export default SelectedPolygon;
